import React from "react";
import CurrencyFormat from "react-currency-format";

const formData = [
  {
    info: "Runs",
    name: "runs",
  },
  {
    info: "Wins",
    name: "wins",
  },
  {
    info: "2NDs",
    name: "second",
  },
  {
    info: "3RDs",
    name: "third",
  },
  {
    info: "Age",
    name: "age",
  },
];

const HorseForm = ({ data }) => {
  return (
    <div>
      <h2 className="font-display font-bold text-h2 text-green-800 mb-8">
        {data.title || "Form"}
      </h2>
      <div className="bg-gray-200 border border-gray-300 rounded-md py-4 px-6 flex items-center justify-between sm:grid sm:grid-cols-3">
        {formData.map(({ info, name }) => (
          <div className="p-2" key={info}>
            <h4 className="paragraph-lg text-gray-600">{info}</h4>
            <h5 className="mt-4 font-sans font-bold text-h3 text-green-700">
              {data[name]}
            </h5>
          </div>
        ))}
        <div className="p-2">
          <h4 className="paragraph-lg text-gray-600">Earnings</h4>
          <h5 className="mt-4 font-sans font-bold text-h3 text-yellow-400">
            <CurrencyFormat
              value={data.earnings}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"£"}
            />
          </h5>
        </div>
      </div>
      <div className="h-px w-full bg-gray-300 my-8" />
    </div>
  );
};

export default HorseForm;
